module.exports = __webpack_public_path__ + "images/pdf_thumbnail_26012023.png";